/**
 * AI Models Configuration
 * 멀티 프로바이더 지원: AWS Bedrock, OpenAI, Google, Perplexity
 */

export const AI_MODELS = [
  // ============================================
  // AWS Bedrock - Claude (Anthropic) - Global Inference Profiles
  // ============================================
  {
    id: 'claude-opus-4-6',
    name: 'Claude Opus 4.6',
    provider: 'Anthropic',
    providerId: 'anthropic',
    modelId: 'us.anthropic.claude-opus-4-6-v1',
    description: 'Best performance, complex tasks',
    icon: '👑',
    color: '#7C3AED',
    bgColor: 'bg-purple-500/10',
    textColor: 'text-purple-500',
    maxTokens: 8192,
    isDefault: true,
  },
  {
    id: 'claude-sonnet-4-6',
    name: 'Claude Sonnet 4.6',
    provider: 'Anthropic',
    providerId: 'anthropic',
    modelId: 'us.anthropic.claude-sonnet-4-6',
    description: 'Fast and powerful balance',
    icon: '🟠',
    color: '#D97706',
    bgColor: 'bg-amber-500/10',
    textColor: 'text-amber-500',
    maxTokens: 8192,
  },
  {
    id: 'claude-haiku-4-5',
    name: 'Claude Haiku 4.5',
    provider: 'Anthropic',
    providerId: 'anthropic',
    modelId: 'us.anthropic.claude-haiku-4-5-20251001-v1:0',
    description: 'Ultra-fast responses',
    icon: '⚡',
    color: '#F59E0B',
    bgColor: 'bg-yellow-500/10',
    textColor: 'text-yellow-500',
    maxTokens: 8192,
  },

  // ============================================
  // OpenAI GPT
  // ============================================
  {
    id: 'gpt-4o',
    name: 'GPT-4o',
    provider: 'OpenAI',
    providerId: 'openai',
    modelId: 'gpt-4o',
    description: 'Latest GPT model',
    icon: '🟢',
    color: '#10B981',
    bgColor: 'bg-emerald-500/10',
    textColor: 'text-emerald-500',
    maxTokens: 4096,
    hidden: true,
  },
  {
    id: 'gpt-4o-mini',
    name: 'GPT-4o Mini',
    provider: 'OpenAI',
    providerId: 'openai',
    modelId: 'gpt-4o-mini',
    description: 'Fast and affordable',
    icon: '🌿',
    color: '#34D399',
    bgColor: 'bg-green-400/10',
    textColor: 'text-green-400',
    maxTokens: 4096,
    hidden: true,
  },

  // ============================================
  // Google Gemini
  // ============================================
  {
    id: 'gemini-2-flash',
    name: 'Gemini 2.0 Flash',
    provider: 'Google',
    providerId: 'google',
    modelId: 'gemini-2.0-flash',
    description: 'Fast multimodal',
    icon: '🔵',
    color: '#3B82F6',
    bgColor: 'bg-blue-500/10',
    textColor: 'text-blue-500',
    maxTokens: 8192,
    hidden: true,
  },
  {
    id: 'gemini-1-5-pro',
    name: 'Gemini 1.5 Pro',
    provider: 'Google',
    providerId: 'google',
    modelId: 'gemini-1.5-pro',
    description: 'High-performance multimodal',
    icon: '💎',
    color: '#6366F1',
    bgColor: 'bg-indigo-500/10',
    textColor: 'text-indigo-500',
    maxTokens: 8192,
    hidden: true,
  },
  {
    id: 'nanobanana',
    name: 'Nanobanana',
    provider: 'Google',
    providerId: 'google',
    modelId: 'gemini-2.0-flash-exp-image-generation',
    description: 'AI image generation',
    icon: '🍌',
    color: '#F59E0B',
    bgColor: 'bg-yellow-500/10',
    textColor: 'text-yellow-500',
    maxTokens: 8192,
    isImageModel: true,
    hidden: true, // hidden from general model list
  },

  // ============================================
  // ElevenLabs (TTS / Podcast)
  // ============================================
  {
    id: 'elevenlabs',
    name: 'ElevenLabs',
    provider: 'ElevenLabs',
    providerId: 'elevenlabs',
    modelId: 'eleven_multilingual_v2',
    description: 'TTS & Podcast',
    icon: '🎙️',
    color: '#6366F1',
    bgColor: 'bg-indigo-500/10',
    textColor: 'text-indigo-500',
    maxTokens: 5000, // ~5000 character limit
    isAudioModel: true,
    hidden: true, // hidden from general model list
  },

  // ============================================
  // Perplexity (Web Search)
  // ============================================
  {
    id: 'perplexity-sonar-pro',
    name: 'Perplexity Pro',
    provider: 'Perplexity',
    providerId: 'perplexity',
    modelId: 'sonar-pro',
    description: 'Real-time web search',
    icon: '🟣',
    color: '#8B5CF6',
    bgColor: 'bg-purple-500/10',
    textColor: 'text-purple-500',
    maxTokens: 4096,
    hidden: true,
  },
  {
    id: 'perplexity-sonar',
    name: 'Perplexity Sonar',
    provider: 'Perplexity',
    providerId: 'perplexity',
    modelId: 'sonar',
    description: 'Fast web search',
    icon: '🔮',
    color: '#A78BFA',
    bgColor: 'bg-violet-400/10',
    textColor: 'text-violet-400',
    maxTokens: 4096,
    hidden: true,
  },

  // ============================================
  // AWS Bedrock - Amazon Nova (APAC Inference Profiles)
  // ============================================
  {
    id: 'nova-pro',
    name: 'Nova Pro',
    provider: 'Amazon',
    providerId: 'amazon',
    modelId: 'apac.amazon.nova-pro-v1:0',
    description: 'Multimodal support',
    icon: '🌟',
    color: '#2563EB',
    bgColor: 'bg-blue-500/10',
    textColor: 'text-blue-500',
    maxTokens: 4096,
    hidden: true,
  },
  {
    id: 'nova-lite',
    name: 'Nova Lite',
    provider: 'Amazon',
    providerId: 'amazon',
    modelId: 'apac.amazon.nova-lite-v1:0',
    description: 'Fast and affordable',
    icon: '💫',
    color: '#0EA5E9',
    bgColor: 'bg-sky-500/10',
    textColor: 'text-sky-500',
    maxTokens: 4096,
    hidden: true,
  },
];

export const DEFAULT_MODEL = AI_MODELS.find(m => m.isDefault) || AI_MODELS[0];

export const getModelById = (id) => AI_MODELS.find(m => m.id === id) || DEFAULT_MODEL;

export const getModelByModelId = (modelId) => AI_MODELS.find(m => m.modelId === modelId) || DEFAULT_MODEL;

// Group models by provider
export const getModelsByProvider = (providerId) => AI_MODELS.filter(m => m.providerId === providerId);

export const PROVIDERS = [
  { id: 'anthropic', name: 'Anthropic', color: '#D97706' },
  { id: 'openai', name: 'OpenAI', color: '#10B981' },
  { id: 'google', name: 'Google', color: '#3B82F6' },
  { id: 'perplexity', name: 'Perplexity', color: '#8B5CF6' },
  { id: 'amazon', name: 'Amazon', color: '#FF9900' },
];

export default AI_MODELS;
